import { CreditCardToken } from './payment-creditcard-token';
import { handleRedirection } from './payment-redirection';
import { CardSlider } from './card-slider';
import { isSecondaryBlockOpened } from './payment';
import { i18n } from '@/commons/utils';

export function IngenicoBlock(page) {
  const block = this;

  block.init = params => {
    block.container = params.container;
    block.parent = params.parent;
    block.onExpressConfirmation = params.onExpressConfirmation;
    block.header = block.container.querySelector('.dkt-block-header');
    block.content = block.container.querySelector('.dkt-block-content');
    block.id = block.container.getAttribute('data-payment-type-id');

    if (document.getElementById('orderTrackingUrl') !== null) {
      block.orderTracking = document.getElementById('orderTrackingUrl').value;
    }
    block.orderId = params.orderId;
    block.isWallet = params.isWallet || false;
    block.createCardButtons = block.container.querySelectorAll('.dkt-create-card');
    block.saveInWallet = block.container.querySelector('#save-ingenico-card');
    block.multiEnabled = block.container.getAttribute('data-multi-enabled');

    block.state = {
      selected: params.selected || false,
      hasError: false
    };
    block.cards = block.container.querySelectorAll('.dkt-card-slider-item');
    block.tokens = [];
    if (block.cards.length > 0) {
      block.slider = new CardSlider(block);
    }
    block.cards.forEach((card, index) => {
      const token = new CreditCardToken(block.slider);
      let isNewAccount = false;
      let isSelected = false;
      if (card.getAttribute('data-is-favorite') === null) {
        isNewAccount = true;
        if (block.tokens.length === 0) {
          isSelected = true;
        }
        block.newCard = card;
      }
      token.init({
        container: card,
        index,
        isSelected,
        isWallet: block.isWallet
      });
      token.isNewAccount = isNewAccount;
      block.tokens.push(token);
      if (isNewAccount) {
        card.addEventListener('click', block.onNewCardFormDisplayChanged);
      }
    });
    block.isExpress = params.isExpress || false;
    block.isCheckout = params.isCheckout || false;
    block.canAddNewCard = params.canAddNewCard || (block.container.querySelector('.dkt-flipable') !== null);
    if (block.state.selected === true) {
      block.select();
    }

    if (!block.canAddNewCard) {
      block.hideSliderActions();
    }

    block.events();
  };

  block.events = () => {
    if (block.header !== null) {
      block.header.addEventListener('click', block.select);
    }
    document.addEventListener('clickedOnPay', block.submitPayment);
    document.addEventListener('PrimaryPaymentBlockSelected', block.unselect);
  };

  block.select = event => {
    if ((block.state.selected === false && event) || !event) {
      document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
        bubbles: false,
        cancelable: false,
        detail: {
          'multiEnabled': block.multiEnabled
        }
      }));

      $(block.content).slideDown('fast', () => {
        block.container.className += ' dkt-block--selected dkt-block--open';
      });
      block.state.selected = true;
      if (block.slider) {
        block.slider.init({
          container: block.container.querySelector('.dkt-card-slider-container'),
          parent: block,
          displayNewCard: false
        });
      }
      if (block.isWallet === false) {
        block.selectFavoriteToken();
      }

      if (!block.canAddNewCard) {
        block.hideSliderActions();
      }
    }
  };

  block.unselect = () => {
    $(block.content).slideUp('normal', () => {
      block.container.classList.remove('dkt-block--selected');
      block.container.classList.remove('dkt-block--open');
    });
    block.state.selected = false;
  };

  block.hideSliderActions = () => {
    const sliderActions = block.container.querySelectorAll('.dkt-card-slider-actions');
    if (sliderActions) {
      sliderActions.classList.add('dkt-card-slider-actions--hidden');
    }
  };

  block.selectFavoriteToken = () => {
    if (block.isTokenFavorite() === true) {
      block.tokens.forEach(token => {
        if (token.isFavorite === true) {
          token.select();
          block.slider.current = block.tokens.indexOf(token);
          block.slider.changeCurrent();
        }
      });
    } else if (block.tokens.length > 0) {
      block.slider.current = 0;
      block.slider.changeCurrent();
      block.tokens[0].select();
    }
  };

  block.isTokenSelected = () => {
    const selectedToken = block.tokens.filter(token => token.state.isSelected === true);
    return (selectedToken.length >= 1);
  };

  block.isTokenFavorite = () => {
    const favoriteToken = block.tokens.filter(token => token.state.isFavorite === true);
    return (favoriteToken.length >= 1);
  };

  block.onNewCardFormDisplayChanged = () => {
    block.slider.container.classList.add('dkt-card-slider-container--new');
    block.tokens[block.tokens.length - 1].select();
  };

  block.submitPayment = () => {
    if (block.state.selected === false) return; // Check if this mean of payment is selected
    if (page.checkTermsOfUse() === false) return; // Check if terms of use are checked
    if (page.checkBillingAddress && page.checkBillingAddress() === false) return; // Check if billing address is OK
    if (page.isFullSecondaryPayment && page.isFullSecondaryPayment() === true) return; // Check if payment is full secondary

    if (block.tokens.length > 0) {
      block.tokens.forEach(token => {
        if (token.state.isSelected === true) {
          if (token.isNewAccount === true) {
            block.submitNewCardPayment();
          } else if (token.isOk()) {
            block.submitTokenPayment(token);
          }
        }
      });
    } else {
      block.submitNewCardPayment();
    }
  };

  block.getRedirectionUrl = () => {
    if (document.getElementById('redirectionUrl') !== null) {
      block.redirectionUrl = `${document.getElementById('redirectionUrl').value}?orderId=${window.tc_vars.order_id}`;
    }
  };

  block.submitTokenPayment = token => {
    block.getRedirectionUrl();
    const params = {
      orderId: block.orderId,
      tokenId: token.tokenId,
      cvc: token.cvc,
      paymentTypeId: block.id,
      redirectionUrl: block.redirectionUrl,
      orderTracking: block.orderTracking,
      orderAttributes: JSON.stringify(page.getAnalyticsInfos()),
      useSecondaryMop: isSecondaryBlockOpened(),
    };
    page.displayLoader();

    cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
      .onSuccess(success)
      .call();

    function success(response) {
      if (response && response.result && response.result.data) {
        const { data } = response.result;
        if (window.cube.config.anly_useLegacy === 'Y') {
          CUBE.Analytics.queue.send('proceedToConfirmation');
        }
        if (data.paymentModifiable === 'false') {
          window.location.reload();
        }

        if (data.redirectConfirmation === 'true') {
          window.location.href = block.redirectionUrl;
        }

        if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
          block.onExpressConfirmation(data.redirectConfirmation);
        }

      } else {
        page.hideLoader();
        page.displayError(response.responseTO.errors[0].message);
      }
    }
  };

  block.submitNewCardPayment = () => {
    const redirectionUrl = cube.$id('redirectionUrl') !== null ? cube.$id('redirectionUrl').value : null;
    const paymentUrl = cube.$id('paymentUrl') !== null ? cube.$id('paymentUrl').value : null;
    const pspRedirectionUrl = cube.$id('pspRedirectionUrl') !== null ? cube.$id('pspRedirectionUrl').value : null;

    const params = {
      paymentTypeId: block.id,
      redirectionUrl,
      paymentUrl,
      pspRedirectionUrl,
      orderAttributes: JSON.stringify(page.getAnalyticsInfos()),
      orderId: block.orderId,
      saveInWallet: block.saveInWallet && block.saveInWallet.checked
    };

    params.useSecondaryMop = isSecondaryBlockOpened();

    if (page.displayLoader) {
      page.displayLoader();
    }

    cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
      .onSuccess(response => handleRedirection(block, response))
      .onError(() => block.submitPaymentError())
      .call();
  };

  block.submitPaymentError = () => {
    if (page.hideLoader) {
      page.hideLoader();
    }
    if (page.displayError) {
      page.displayError(i18n('TECH_0001'));
    }
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-ingenico.js